<template>
  <div class="blog">


    <v-layout>
      <v-flex xs12 md6 offset-sm3>
        <v-card>
          <v-card-media
          v-bind:src="require('@/assets/post1.jpg')"
          aspect-ratio="2.75">
        </v-card-media>

          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">A Proof of Cayley's Formula</h3>
              <div> In this post, we will see an elegant proof of Cayley's formula (due to H. W. Moon).
                For those unaware, Cayley's formula (a result in graph theory) states that for every positive integer
                <span v-katex="' n '"></span> the number of trees on <span v-katex="' n '"></span> labeled vertices is
                <span v-katex="' n^{n-2}. '" ></span>

              </div>

            </div>
          </v-card-title>

          <v-card-actions>
            <v-btn flat color ="orange" to="/cayley">Read More</v-btn>
          </v-card-actions>
        </v-card>



        <v-card class="mt-4">
          <v-card-media
          v-bind:src="require('@/assets/post2.png')"
          aspect-ratio="3">
        </v-card-media>

          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">Coloring Planar Graphs I</h3>
              <div> We will explore some results about planar graphs. We will begin with Euler's theorem for planar graphs,
                and conclude with a proof that all planar graphs are 6-colorable.
              </div>

            </div>
          </v-card-title>

          <v-card-actions>
            <v-btn flat color="orange" to="/planar1">Read More</v-btn>



          </v-card-actions>
        </v-card>

        <v-card class="mt-4">
          <v-card-media
          v-bind:src="require('@/assets/post3.jpeg')"
          aspect-ratio="2">
        </v-card-media>

          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">A Gentle Introduction to Randomized Algorithms</h3>
              <div> The goal of this post is to introduce the use of randomness in designing algorithms.
                We first define the model of computation, and then look at a few examples of randomized algorithms.
              </div>

            </div>
          </v-card-title>

          <v-card-actions>
            <v-btn flat color="orange" to="/random1">Read More</v-btn>



          </v-card-actions>
        </v-card>




      </v-flex>


    </v-layout>


  </div>
</template>


<script>

  export default {

    data () {
      return {
        dialog2: false
      }
    }

  }
</script>
